// Ranger's Wrangler endpoints reply with {error} and, when Wrangler rejected
// the request, {fields}: Wrangler's validation errors, possibly nested.

export const wranglerError = (err, fallback = "Couldn't reach Ranger's server.") => {
  const data = err?.response?.data;
  return data?.error || data?.detail || fallback;
};

/** Wrangler's field errors as lines like "quotas.0.logic: Unknown question 99." */
export const fieldErrors = (err) => {
  const lines = [];
  const walk = (value, path) => {
    if (Array.isArray(value) && value.every((v) => typeof v === 'string')) {
      lines.push(`${path ? `${path}: ` : ''}${value.join(' ')}`);
    } else if (value && typeof value === 'object') {
      Object.entries(value).forEach(([key, v]) => walk(v, path ? `${path}.${key}` : key));
    } else if (value != null) {
      lines.push(`${path ? `${path}: ` : ''}${value}`);
    }
  };
  walk(err?.response?.data?.fields, '');
  return lines;
};
